export const classes = {
  alert: {
    borderRadius: '8px',
  },
  wholeClickable: {
    cursor: 'pointer',
  },
}
